"use client";

import { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "../hooks/use-router";
import { Link } from "react-router-dom";
import Sidebar from "./sidebar";
import { useSelector, useDispatch } from "react-redux";
import { clearUser } from "../store/userSlice";
import { motion } from "framer-motion";
// import { ChevronDown } from "lucide-react"; // Not currently used
import { FaRegUserCircle } from "react-icons/fa";
import {
  AiOutlineShoppingCart,
  AiOutlineHeart,
  AiOutlineSetting,
} from "react-icons/ai";
import summaryApi from "../common/index";
import Context from "../context/index";
import { toast } from "react-hot-toast";
import logo from "../assets/logo/logo.ico";

export default function Navbar() {
  const { items } = useSelector((state) => state.cart);
  const user = useSelector((state) => state?.user?.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const context = useContext(Context);
  if (!context) throw new Error("Navbar must be wrapped in Context.Provider");

  const [isCartOpen, setIsCartOpen] = useState(false);
  // const [activeLink, setActiveLink] = useState("Men"); // Not currently used
  // const [hoverLink, setHoverLink] = useState(null); // Not currently used
  // const [isHoveringCard, setIsHoveringCard] = useState(false); // Not currently used
  // const [isHoveringLink, setIsHoveringLink] = useState(false); // Not currently used
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  // const [isLoading, setIsLoading] = useState(false); // Not currently used
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // const [mobileActiveSubmenu, setMobileActiveSubmenu] = useState(null); // Not currently used

  // const [isNavbarDataLoaded, setIsNavbarDataLoaded] = useState(false); // Not currently used

  // const linkRefs = useRef([]); // Not currently used
  const profileDropdownRef = useRef(null);
  // const [barStyle, setBarStyle] = useState({ left: 0, width: 0 }); // Not currently used

  const handleLogout = async () => {
    // setIsLoading(true); // Not currently used
    try {
      // Set logout flag FIRST before clearing anything
      if (typeof window !== "undefined") {
        localStorage.setItem("justLoggedOut", "true");
      }

      // Clear user state immediately
      dispatch(clearUser());

      // Call logout endpoint to clear cookie on server
      const fetchData = await fetch(summaryApi.logout_user.url, {
        method: summaryApi.logout_user.method,
        credentials: "include", // 🔥 CRITICAL: Must include credentials to send/clear cookies
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await fetchData.json();

      if (data.success) {
        toast.success("Logged out successfully!");
      } else {
        toast.error(data.message || "Logout failed. Please try again.");
      }

      // Clear all storage
      if (typeof window !== "undefined") {
        // Keep the logout flag
        const logoutFlag = localStorage.getItem("justLoggedOut");
        localStorage.clear();
        sessionStorage.clear();
        if (logoutFlag) {
          localStorage.setItem("justLoggedOut", "true");
        }
      }

      // Navigate and force full reload to ensure cookie is cleared
      setTimeout(() => {
        // setIsLoading(false); // Not currently used
        navigate("/");
        window.location.href = "/"; // Force full page reload
      }, 500);
    } catch (error) {
      console.error("Error during logout:", error);
      // Set flag even on error
      if (typeof window !== "undefined") {
        localStorage.setItem("justLoggedOut", "true");
      }
      dispatch(clearUser());
      toast.error("An error occurred. Please try again.");
      // setIsLoading(false); // Not currently used
      setTimeout(() => {
        navigate("/");
        window.location.href = "/"; // Force full page reload
      }, 500);
    }
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const toggleMobileSubmenu = (link) => {
  //   setMobileActiveSubmenu((prev) => (prev === link ? null : link));
  // }; // Not currently used
  return (
    <>
      {/* Top Contact Bar */}
      <div className="w-full bg-[#8B4513] text-white py-2 text-xs md:text-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-2 md:gap-0">
          <div className="flex items-center gap-4 md:gap-6">
            <a href="mailto:imranandsonstraders@gmail.com" className="flex items-center gap-1.5 hover:text-[#D4AF37] transition-colors">
              <svg className="w-3.5 h-3.5 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span>imranandsonstraders@gmail.com</span>
            </a>
            <a href="tel:+447956575153" className="flex items-center gap-1.5 hover:text-[#D4AF37] transition-colors">
              <svg className="w-3.5 h-3.5 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span>+44 7956 575153</span>
            </a>
          </div>
          <div className="text-center md:text-right">
            <span>Sign up for your first order. </span>
            <a href="/signup" className="underline font-semibold hover:text-[#D4AF37] ml-1">
              Sign up now
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation Bar */}
      <nav className="w-full bg-white relative z-50 shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          {/* Top Row: Logo, Search, Icons */}
          <div className="flex items-center justify-between py-4 gap-4">
            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMobileMenuOpen(true)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>

            {/* Center: Logo */}
            <a href="/" className="flex items-center gap-2 flex-1 justify-center md:flex-none">
              <img
                src={logo}
                alt="Imran & Sons Traders Logo"
                className="h-8 w-8 object-cover rounded-full"
              />
              <span className="font-bold text-xl text-[#8B4513] hidden md:inline">Imran & Sons Traders</span>
            </a>

            {/* Center: Search Bar */}
            <div className="hidden md:flex flex-1 max-w-md mx-4">
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Search for Product Brand or Category"
                  className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B4513] focus:border-transparent"
                />
                <svg
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>

            {/* Right: Icons */}
            <div className="flex items-center space-x-3 md:space-x-4 text-black">

              {/* Wishlist Icon */}
              <a href="/wishlist" className="no-underline relative">
                <div className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                  <AiOutlineHeart className="w-6 h-6 text-gray-700" />
                  {user?._id && context?.wishlistCount > 0 && (
                    <div className="absolute -top-1 -right-1 bg-[#8B4513] text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                      {context.wishlistCount}
                    </div>
                  )}
                </div>
              </a>

              {/* Cart Icon */}
              <div
                className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                onClick={() => setIsCartOpen(true)}
              >
                <AiOutlineShoppingCart className="w-6 h-6 text-gray-700" />
                <div className="absolute -top-1 -right-1 bg-[#8B4513] text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {user?._id ? context?.cartProductCount || 0 : items.length}
                </div>
              </div>

              {/* User Profile */}
              {user?._id ? (
                <div className="relative" ref={profileDropdownRef}>
                  <div
                    className="p-2 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                    onClick={toggleProfileDropdown}
                  >
                    {user?.profilePic ? (
                      <img
                        src={
                          user.profilePic.startsWith("http")
                            ? user.profilePic
                            : `https://dates-website-backend.vercel.app/${user.profilePic}`
                        }
                        alt={user.name || "User"}
                        className="w-6 h-6 rounded-full object-cover"
                      />
                    ) : (
                      <FaRegUserCircle className="w-6 h-6 text-gray-700" />
                    )}
                  </div>
                  {isProfileDropdownOpen && (
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl z-50 border border-gray-200"
                    >
                      <div className="py-2">
                        <a
                          href={`/user-profile/${user?._id}`}
                          className="block px-4 py-2 text-sm hover:bg-gray-100"
                          onClick={() => setIsProfileDropdownOpen(false)}
                        >
                          Profile
                        </a>
                        {user?.role === "ADMIN" && (
                          <button
                            onClick={() => {
                              setIsProfileDropdownOpen(false);
                              navigate("/admin-panel/all-products");
                            }}
                            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                          >
                            Admin Panel
                          </button>
                        )}
                        <button
                          onClick={() => {
                            setIsProfileDropdownOpen(false);
                            handleLogout();
                          }}
                          className="block w-full text-left px-4 py-2 text-sm hover:bg-red-50 text-red-600"
                        >
                          Logout
                        </button>
                      </div>
                    </motion.div>
                  )}
                </div>
              ) : (
                <a href="/login" className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                  <FaRegUserCircle className="w-6 h-6 text-gray-700" />
                </a>
              )}

            </div>
          </div>

          {/* Bottom Row: Navigation Menu */}
          <div className="hidden md:flex items-center justify-center border-t border-gray-200 py-3 gap-6">
            <a href="/" className="text-gray-700 hover:text-[#8B4513] font-medium transition-colors">
              Home
            </a>
            <a href="/products" className="text-gray-700 hover:text-[#8B4513] font-medium transition-colors">
              Shop
            </a>
            <a href="/about-us" className="text-gray-700 hover:text-[#8B4513] font-medium transition-colors">
              About Us
            </a>
            <a href="/contact-us" className="text-gray-700 hover:text-[#8B4513] font-medium transition-colors">
              Contact
            </a>
            <Link to="/privacy-policy" className="text-gray-700 hover:text-[#8B4513] font-medium transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>

      <Sidebar
        isCartOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
      />
      {isCartOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-40"
          onClick={() => setIsCartOpen(false)}
        />
      )}
        {/* Mobile Menu */}
        <div
          className={`md:hidden fixed top-0 left-0 w-full h-screen bg-white transform transition-transform duration-300 ease-in-out z-40 overflow-y-auto shadow-2xl ${
            isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="pt-8 pb-8 px-6 bg-gradient-to-b from-white to-gray-50 min-h-full">
            {/* Close button */}
            <div className="mb-8 flex justify-between items-center">
              <div className="flex items-center gap-2">
                <img
                  src={logo}
                  alt="Logo"
                  className="h-8 w-8 object-cover rounded-full border-2 border-[#D4AF37]"
                />
                <span className="font-bold text-lg bg-gradient-to-r from-[#8B4513] via-[#D4AF37] to-[#654321] bg-clip-text text-transparent">
                  Imran & Sons
                </span>
              </div>
              <button
                onClick={() => setIsMobileMenuOpen(false)}
                className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              >
                <svg
                  className="w-6 h-6 text-gray-700"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* User Profile Section - Mobile */}
            {user?._id && (
              <div className="mb-6 pb-6 border-b border-gray-200">
                <a
                  href={`/user-profile/${user?._id}`}
                  className="flex items-center space-x-4 no-underline p-3 rounded-xl hover:bg-gray-50 transition-colors duration-200"
                >
                  {user?.profilePic ? (
                    <img
                      src={
                        user.profilePic.startsWith("http")
                          ? user.profilePic
                          : `https://dates-website-backend.vercel.app/${user.profilePic}`
                      }
                      alt={user.name || "User"}
                      className="w-12 h-12 object-cover rounded-full border-2 border-[#D4AF37] shadow-md"
                    />
                  ) : (
                    <div className="w-12 h-12 bg-gradient-to-br from-[#8B4513] to-[#654321] rounded-full flex items-center justify-center border-2 border-[#D4AF37] shadow-md">
                      <FaRegUserCircle className="w-6 h-6 text-[#D4AF37]" />
                    </div>
                  )}
                  <div>
                    <p className="font-semibold text-gray-900 text-base">
                      {user.name || "User"}
                    </p>
                    <p className="text-sm text-gray-500">View Profile</p>
                  </div>
                </a>
              </div>
            )}

            {/* Quick Actions - Mobile */}
            {user?._id && (
              <div className="mb-6 space-y-2">
                <a
                  href="/wishlist"
                  className="flex items-center justify-between py-3 px-4 text-gray-700 no-underline rounded-xl hover:bg-gradient-to-r hover:from-[#D4AF37]/10 hover:to-[#8B4513]/10 transition-all duration-200"
                >
                  <div className="flex items-center space-x-3">
                    <AiOutlineHeart className="w-5 h-5 text-[#8B4513]" />
                    <span className="font-medium">Wishlist</span>
                  </div>
                  {context?.wishlistCount > 0 && (
                    <span className="bg-gradient-to-br from-[#D4AF37] to-[#8B4513] text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
                      {context.wishlistCount}
                    </span>
                  )}
                </a>

                {/* Cart menu item (opens sidebar) */}
                <button
                  type="button"
                  onClick={() => setIsCartOpen(true)}
                  className="flex items-center justify-between py-3 px-4 text-gray-700 no-underline w-full rounded-xl hover:bg-gradient-to-r hover:from-[#D4AF37]/10 hover:to-[#8B4513]/10 transition-all duration-200"
                  aria-label="Open cart sidebar"
                >
                  <div className="flex items-center space-x-3">
                    <AiOutlineShoppingCart className="w-5 h-5 text-[#8B4513]" />
                    <span className="font-medium">Cart</span>
                  </div>

                  {(context?.cartProductCount || 0) > 0 && (
                    <span className="bg-gradient-to-br from-[#D4AF37] to-[#8B4513] text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
                      {context?.cartProductCount || 0}
                    </span>
                  )}
                </button>

                {user?.role === "ADMIN" && (
                  <button
                    onClick={() => {
                      navigate("/admin-panel/all-products");
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex items-center space-x-3 py-3 px-4 text-gray-700 w-full text-left rounded-xl hover:bg-gradient-to-r hover:from-[#D4AF37]/10 hover:to-[#8B4513]/10 transition-all duration-200"
                  >
                    <AiOutlineSetting className="w-5 h-5 text-[#8B4513]" />
                    <span className="font-medium">Admin Panel</span>
                  </button>
                )}
              </div>
            )}

            {/* Navigation Links - Mobile */}
            <div className="mt-6 pt-6 border-t border-gray-200 space-y-2">
              <a
                href="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-3 px-4 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition-colors"
              >
                Home
              </a>
              <a
                href="/products"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-3 px-4 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition-colors"
              >
                Shop
              </a>
              <a
                href="/about-us"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-3 px-4 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition-colors"
              >
                About Us
              </a>
              <a
                href="/contact-us"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-3 px-4 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition-colors"
              >
                Contact
              </a>
              <Link
                to="/privacy-policy"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-3 px-4 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition-colors"
              >
                Privacy Policy
              </Link>
            </div>

            {/* Login/Logout Button - Mobile */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              {user?._id ? (
                <button
                  onClick={handleLogout}
                  className="w-full bg-gradient-to-r from-red-500 to-red-600 text-white py-3.5 px-4 rounded-xl font-semibold hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02]"
                >
                  Logout
                </button>
              ) : (
                <a href="/login" className="no-underline">
                  <button className="w-full bg-gradient-to-r from-[#8B4513] via-[#D4AF37] to-[#654321] text-white py-3.5 px-4 rounded-xl font-semibold hover:shadow-xl transition-all duration-200 transform hover:scale-[1.02] shadow-lg">
                    Login
                  </button>
                </a>
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
